"use strict";
/*
 * Created on 10 11 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * {@link VAT} rate
 *
 * @author JMe
 */


var VATRate =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(VATRate, _DomainObject_1$Domai);

  /**
   * @param validFrom
   * @param validTo
   * @param rate rate in percentage
   */
  function VATRate(validFrom, validTo, rate) {
    var _this;

    _classCallCheck(this, VATRate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VATRate).call(this));
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.rate = rate;
    return _this;
  }

  return VATRate;
}(DomainObject_1.DomainObject);

exports.VATRate = VATRate; // tslint:disable-next-line:member-ordering

VATRate.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(VATRate.name);
  return {
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN),
    rate: builder.bigNum('rate')
  };
}();